// extracted by mini-css-extract-plugin
export default {"dnd-uploader":"R3UWK","dndUploader":"R3UWK"};